module.exports = __webpack_public_path__ + "static/media/ad1.5a6d113a.png";